module.exports = __webpack_public_path__ + "static/media/robot_fantasia.bd260a07.mp4";